import { render } from "./UserCreditsDeductAdmin.vue?vue&type=template&id=7a0494dc"
import script from "./UserCreditsDeductAdmin.vue?vue&type=script&lang=js"
export * from "./UserCreditsDeductAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__